import React from "react";
import { Card, Divider, Layout, Grid } from "antd";
import styles from "./styles/SidePreviewScreen.module.css";
import { LOGIN_BG } from "../constants";
import DisplayShowcase from "../onboarding/DisplayShowcase";

const { useBreakpoint } = Grid;

const SidePreviewScreen = ({
    title,
    subtitle = false,
    logo,
    children,
    center = true,
    styles_card = {
        width: "100%",
        maxWidth: "400px",
    },
}) => {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const cardStyle = isMobile
        ? { ...styles_card, maxWidth: "100%" }
        : styles_card;

    const bg_style = {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
    };
    return (
        <Layout className={styles.wrapper} style={bg_style}>
            <div className={styles.right_side}>
                {logo && (
                    <div className={styles.logo_wrapper}>
                        <img src={logo} alt="logo" className={styles.logo} />
                    </div>
                )}
                <div className={styles.card_wrapper}>
                    <div style={cardStyle} className={styles.card}>
                        <div>
                            <h1>{title}</h1>
                            {subtitle && (
                                <p className={styles.subtitle}>{subtitle}</p>
                            )}
                        </div>
                        {children}
                    </div>
                </div>
            </div>
            {!isMobile && (
                <div
                    className={styles.left_side}
                    style={{ background: LOGIN_BG }}
                >
                    {/* <DisplayShowcase /> */}
                    <h1>PLACEHOLDER</h1>
                </div>
            )}
        </Layout>
    );
};

export default SidePreviewScreen;
